import { render, staticRenderFns } from "./ModalTermsOfUse.vue?vue&type=template&id=56485dce"
import script from "./ModalTermsOfUse.vue?vue&type=script&lang=js"
export * from "./ModalTermsOfUse.vue?vue&type=script&lang=js"
import style0 from "./ModalTermsOfUse.vue?vue&type=style&index=0&id=56485dce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports